import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import DOMPurify from 'dompurify';
import marked from 'marked';
import Typography from '@material-ui/core/Typography';
import { useIntl, FormattedTime } from 'react-intl';
import './styles.css';

const styles = (theme) =>
	({
		root :
	{
		display    : 'flex',
		flexShrink : 0,
		// backgroundColor: '#a9daeb',
		boxShadow  : 'none',
		padding    : '0.5rem 0',
		wordWrap   : 'break-word',
		wordBreak  : 'break-all',
		alignItems : 'center',
		fontFamily : 'Twemoji Country Flags'
	},
		single :
	{
		marginTop : theme.spacing(1)
	},
		combinedBegin :
	{
		marginTop : theme.spacing(1)
	},

		combinedMiddle :
	{
		marginBottom : theme.spacing(0)
	},
		combinedEnd :
	{
		marginBottom : theme.spacing(0)
	},
		combinedTime :
	{
		width          : '75px',
		alignSelf      : 'center',
		fontSize       : '13px',
		// color          : '#999999',
		color          : '#000000ab',
		display        : 'flex',
		justifyContent : 'center'
	},
		sentMessage :
	{
		// alignSelf: 'flex-end',
		flexDirection : 'row-reverse',
		width         : '100%'
	},
		receivedMessage :
	{
		// alignSelf: 'flex-start',
		width      : '100%',
		alignItems : 'flex-end'

	},
		name : {

		},
		avatar : {
			display        : 'flex',
			justifyContent : 'center',
			padding        : '12px 6px 20px 0px',
			'& img'        : {
				borderRadius    : '50%',
				width           : '2rem',
				height          : '2rem',
				alignSelf       : 'center',
				objectFit       : 'cover',
				backgroundColor : '#e0e0e085'
			}
		},
		meContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : '90%',
		alignItems    : 'flex-end',
		marginTop     : '8px',
		paddingRight  : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		peerContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : '90%',
		marginTop     : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		isSeen : {
		// backgroundColor : '#e0e0e085',
			transition : 'background-color 1s'
		}
	});

const Message = (props) =>
{
	const intl = useIntl();

	const linkRenderer = new marked.Renderer();

	linkRenderer.link = (href, title, text) =>
	{
		title = title ? title : href;
		text = text ? text : href;

		return `<a target='_blank' href='${href}' title='${title}'>${text}</a>`;
	};

	const allowedHTMLNodes = {
		ALLOWED_TAGS : [
			'a', 'b', 'strong', 'i',
			'em', 'u', 'strike', 'p',
			'br'
		],
		ALLOWED_ATTR : [ 'href', 'target', 'title' ]
	};

	const {
		avatar,
		text,
		time,
		name,
		classes,
		isseen,
		sender,
		// refMessage,
		format,
		chatBackgroundColor,
		isPrivateMessage
	} = props;

	const [ imageError, setImageError ] = useState(false);

	const handleImageError = () =>
	{
		setImageError(true);
	};

	return (
		<div
			className={classnames(
				classes.root,
				sender === 'client' ? classes.sentMessage : classes.receivedMessage,
				// isseen ? classes.isSeen : null,
				classes[format]
			)}
			// style={{ backgroundColor: isseen ? chatBackgroundColor : null }}
			data-name={name}
			data-isseen={isseen}
			data-time={time}
		// ref={refMessage}
		>
			{sender !== 'client' &&
				<div className={classes.avatar}>
					<img onError={(e) => { e.target.onerror = null; handleImageError(); }} src={avatar && avatar !== '' && !imageError ? `https://${import.meta.env.VITE_s3Bucket}.s3.${import.meta.env.VITE_s3Region}.amazonaws.com/public/profileImages/${avatar}` : 'images/avatar.svg'} alt='Avatar' />
					{/* {(format === 'single' || format === 'combinedBegin') && 'hidden' ?
					<img
						src={avatar}
						alt='Avatar'
					/>
					:
					<div className={classes.combinedTime}>
						<FormattedTime value={new Date(time)} />
					</div>
				} */}
				</div>
			}

			{<div className={sender === 'client' ? classes.meContent : classes.peerContent}>
				<div className={sender === 'client' ? 'meMsg' : 'peerMsg'} style={sender === 'client' ? { backgroundColor: '#a9daeb', borderColor: '#a9daeb' } : { backgroundColor: '#eaecf2', borderColor: '#eaecf2' }}>
					{/* Name & Time */}
					{/* {(format === 'single' || format === 'combinedBegin') && */}
					{/* <Typography variant='subtitle1'> */}
					{
						sender === 'client'
							? ''
						// `${intl.formatMessage({
						// 	id: 'room.me',
						// 	defaultMessage: 'Me'
						// })}`
							:
							(!isPrivateMessage && <small>{name}</small>)
					}
					{/* </Typography> */}
					{/* } */}
					<Typography
						variant='subtitle1'
						dangerouslySetInnerHTML={{
							__html : DOMPurify.sanitize(
								marked.parse(text, { renderer: linkRenderer }),
								allowedHTMLNodes
							)
						}}
						className='flagss'
					/>
				</div>
				<small className='small'>
					<FormattedTime value={new Date(time)} />
				</small>
			</div>}
		</div>
	);
};

Message.propTypes =
{
	avatar              : PropTypes.string,
	text                : PropTypes.string,
	time                : PropTypes.string,
	name                : PropTypes.string,
	classes             : PropTypes.object.isRequired,
	isseen              : PropTypes.bool,
	sender              : PropTypes.string.isRequired,
	refMessage          : PropTypes.any,
	width               : PropTypes.number,
	format              : PropTypes.string.isRequired,
	chatBackgroundColor : PropTypes.string.isRequired,
	isPrivateMessage    : PropTypes.bool.isRequired
};

export default withStyles(styles)(Message);
